<form>
  {#if value}
    <div>Input: <strong>{value}</strong> <a href="#" on:click={handleClear} class="changeLink">&#9998;</a></div>
  {:else}
    <label for="input">Select Input Type:</label>
    <Select listPlacement="bottom" id="input" {items} on:select={handleSelect} on:clear={handleClear}></Select>
  {/if}
</form>

<script>
	import Select from 'svelte-select';

	const items = [
		{value: 'data', label: 'Data'},
    {value: 'boolean', label: 'Boolean'},
		{value: 'string', label: 'String'},
		{value: 'number', label: 'Number'},
    {value: 'range', label: 'Range'},
    {value: 'select', label: 'Select'},
    {value: 'object', label: 'Object'},
	];

	export let value;

	function handleSelect(event) {
		value = event.detail.value;
	}

	function handleClear() {
		value = undefined;
	}
</script>

<style>
	form {
    width: calc(100% - 2rem);
		background: #efefef;
		padding: 1rem;
	}

	label {
		margin: 0 0 10px;
	}
  .changeLink {
    display: inline-block;
    float: right;
  }
</style>
